import Modal from 'react-modal';
import MgpFormInput from '../../elements/MgpFormInput/MgpFormInput';
import { UseFormRegister } from 'react-hook-form';
import { handleKeyDown } from '../../utils/utils';
import MgpFormCheckbox from '../../elements/MgpFormCheckbox/MgpFormCheckbox';


type PhoneNumberConfirmModalProps = {
    isOpen?: boolean;
    onConfirmAction: () => void;
    onCloseModal: () => void;    
    register: UseFormRegister<any>;
    errors?: any;
    watch?: any;
    handleChangeisForeignMobileCheckbox?: any;
    handleChangePhoneNumber?: any
};

export default function PhoneNumberConfirmModal({isOpen = false, onConfirmAction, onCloseModal, register, errors, watch, handleChangeisForeignMobileCheckbox, handleChangePhoneNumber }: PhoneNumberConfirmModalProps) {

    return(
        <Modal isOpen={isOpen} onRequestClose={onCloseModal}>
            <div className="modale open">
                <div className="modale--content">
                <div className="modale--content--template">
                    <div className="modale--main-width-entreprise p-lg shadow-bleu m-y-xl bg-blanc " style={{height: "auto", width: "90vw", maxWidth: "800px"}}>
                        <form>
                            <div className="mb-lg mt-lg text" > 
                                <p className='text ta-justify mb-md' >Vous allez recevoir un code pour la signature électronique par votre numéro téléphone portable. Veuillez vérifier le numéro ci-dessous ou le modifier si vous souhaitez recevoir le code sur un autre numéro de téléphone.</p>
                                <div className="form-row">
                                    <div className='form-group mw-60'>
                                        <p className='text fw-medium'>Votre numéro de téléphone pour recevoir le code <span className='fushia'>(*)</span></p>
                                        <div className='form-group form-check mw-100'>
                                            <MgpFormCheckbox
                                                id='isForeignMobile' 
                                                label="Numéro hors France métropolitaine" 
                                                register={register} 
                                                errors={errors} 
                                                required={false}
                                                inputSize='small'
                                                onChange={(e: any) => handleChangeisForeignMobileCheckbox(e)}
                                            />
                                        </div>
                                        <div className='mt-sm'>
                                            {
                                                watch("isForeignMobile") ?
                                                <MgpFormInput
                                                    label=""
                                                    id="phoneNumber"
                                                    placeholder="Ex: 00xxxxxxxx ou +xxxxxxxxxx"
                                                    labelFontWeight='medium'
                                                    maxLength={15}
                                                    register={register} 
                                                    errors={errors}
                                                    required={true}
                                                    value={watch("phoneNumber")}
                                                />
                                                :
                                                <MgpFormInput
                                                    label=""
                                                    id="phoneNumber"
                                                    placeholder="Ex: 06 05 04 03 02"
                                                    labelFontWeight='medium'
                                                    maxLength={14}
                                                    autospace={2}
                                                    register={register} 
                                                    errors={errors}
                                                    required={true}
                                                    value={watch("phoneNumber")}
                                                    onChange={(e) => handleChangePhoneNumber(e)}
                                                />
                                            }
                                        </div>
                                    </div>        
                                </div>
                                {
                                    watch("isForeignMobile") &&
                                        <div className="form-group mw-60 mt-sm">
                                            <p className='bg-menthe blanc p-xs flex va-center jc-start' style={{gap: "10px", flexWrap: "unset"}}>
                                                <i className='icon-info blanc '></i>
                                                <span >Veuillez saisir votre numéro de mobile complet avec l'indicatif.</span>
                                            </p>
                                        </div>
                                } 
                            </div>
                        
                            
                            <div className="ta-center mt-lg">
                                <a className="cta-bleu ml-x-md" onClick={onConfirmAction} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>Confirmer</a>  
                            </div>
 
                        </form>
                        
                    </div>
                </div>
                </div>
            </div>
        </Modal>
    )
}